import { useTheme } from '../../styles/ThemeContext';

/**
 * Form field wrapper with label
 */
export function Field({ l, children }) {
  const { theme } = useTheme();

  return (
    <div>
      <label style={theme.label}>{l}</label>
      {children}
    </div>
  );
}
